import type { Asset } from 'contentful'
import type { FC } from 'react'

import { BORDER_RADIUS } from 'components/Button/border-radius'
import { NextSeo } from 'next-seo'
import styled from 'styled-components'
import { contentfulImageToOgImage } from 'utils/content-pages/images'
import { ContentfulImage } from 'views/contentful/components/ContentfulImage'

const _StoreImageBanner: FC<{ className?: string; image: Asset }> = ({ className, image }) => {
  const openGraph = image.fields.file.url
    ? {
        images: [
          {
            url: contentfulImageToOgImage(image.fields.file.url),
          },
        ],
      }
    : undefined

  return (
    <div className={className}>
      <NextSeo openGraph={openGraph} />
      <ContentfulImage image={image} />
    </div>
  )
}

_StoreImageBanner.displayName = 'StoreImageBanner'

export const StoreImageBanner = styled(_StoreImageBanner)({
  position: 'relative',
  width: '100%',
  height: 'auto',

  img: {
    ...BORDER_RADIUS,
  },
})
